import {Authorization, Info, LastHref} from "@/constants/cacheKey";

/**
 * 取缓存值
 * @param {*} key
 * @param {*} options
 */
export const getCache = (key: string): any => {
    const data = localStorage.getItem(key);
    if (!data) {
        return null;
    }
    try {
        return JSON.parse(data)
    } catch {
        return data
    }
};

/**
 * 设置缓存值
 * @param {*} key
 * @param {*} value
 */
export const setCache = (
    key: string,
    value: string | Record<string, unknown> | Array<any>[]
): void => {
    localStorage.setItem(key, typeof value === "object" ? JSON.stringify(value) : value);
};

/**
 * 清除缓存
 * @param key
 * @param isSessionStorage
 */
export const removeCache = (key: string): void => {
    localStorage.removeItem(key);
};

/**
 * 获取token
 * @returns
 */
export const getToken = (): string | null => {
    const dataStr = localStorage.getItem(Authorization)
    if (!dataStr) {
        return null
    }
    try {
        const data = JSON.parse(dataStr)
        const time = (new Date()).getTime()
        if (time >= data.expiration) {
            removeCache(Authorization)
            removeCache(LastHref)
            removeCache(Info)
            return null
        }
        return data.token
    } catch {
        return dataStr
    }
};

/**
 * 权限判断
 * @returns
 */
export const hasPermissions = (key: string): any => {
    const data = getCache(Info);
    if (!data || !data.menuPermission) {
        return false;
    }

    let menuPermission = data.menuPermission
    return menuPermission.includes(key)
};
